import React, { useState } from 'react';
import { useForm } from "antd/lib/form/Form";
import { useTranslation } from "react-i18next";
import { Button, Form, message, Modal, Select, Spin } from "antd";
import dayjs from "dayjs";

interface IProps {
    type: "mts" | "leasing" | "cooperatives";
    title: string;
    getReport: (payload: {
        years?: number[];
        languageEnum: string;
    }) => Promise<Blob>;

    show: boolean;
    onHide: () => void;
}

const ReportDepartmentMechModal = (props: IProps) => {
    const [form] = useForm();
    const { t } = useTranslation()
    const [loading, setLoading] = useState<boolean>(false);

    const [selectedLanguage, setSelectedLanguage] = useState<string>('');
    const [selectedYear, setSelectedYear] = useState<string[]>([]);

    const languages = [
        { key: "ky", label: "Кыргызский" },
        { key: "ru", label: "Русский" }
    ];

    const years = Array.from({ length: 20 }, (_, i) => (2025 - i).toString());


    const handleSubmit = async () => {
        setLoading(true);

        try {
            const values = await form.validateFields();

            const payload = (props.type === "mts")
              ? { years: selectedYear.map(Number), languageEnum: selectedLanguage }
              : { languageEnum: selectedLanguage };

            const blob = await props.getReport(payload);

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `Report_${props.type}_${dayjs().format("YYYY-MM-DD")}.xlsx`
            );
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            message.success(t('reports.download_success'));
        } catch (error: any) {
            Modal.error({
                title: t("msg.error"),
                content: error.message || t('reports.download_failed'),
            });
        } finally {
            setLoading(false);
        }
    };

    const handleHide = () => {
        form.resetFields();
        props.onHide();
    };

    return (
        <Modal
            title={ props.title}
            open={ props.show }
            onCancel={ handleHide }
            onOk={ handleSubmit }
            okText={ t('general.create') }
            width={ 500 }
            footer={ null }
        >
            <Spin spinning={ loading } tip={ t('reports.loading') }>
                <Form form={ form } layout="vertical" autoComplete="off">
                    <div style={ { display: "flex", justifyContent: "space-between" } }>
                        <Form.Item
                            label={ t('reports.select_language') }
                            name="select_language"
                            rules={ [{ required: true, message: t('msg.fill_in_the_field') }] }
                        >
                            <Select
                                value={ selectedLanguage }
                                onChange={ setSelectedLanguage }
                                style={ { width: "200px" } }
                                placeholder={ t('reports.select_language') }
                            >
                                { languages.map((lang) => (
                                    <Select.Option key={ lang.key } value={ lang.key }>
                                        { lang.label }
                                    </Select.Option>
                                )) }
                            </Select>
                        </Form.Item>
                        { props.type !== "cooperatives" && props.type !== "leasing" && (
                            <Form.Item
                                name="years"
                                label={ t('reports.select_years') }
                                rules={ [{ required: true, message: t('msg.fill_in_the_field') }] }>
                                <Select
                                    mode="multiple"
                                    value={ selectedYear }
                                    onChange={ setSelectedYear }
                                    style={ { width: "200px" } }
                                    placeholder={ t('reports.select_years') }
                                >
                                    { years.map((year) => (
                                        <Select.Option key={ year } value={ year }>
                                            { year }
                                        </Select.Option>
                                    )) }
                                </Select>
                            </Form.Item>
                        ) }
                    </div>
                    <div style={ { textAlign: "right", marginTop: "20px" } }>
                        <Button type="primary" block onClick={ handleSubmit } style={ { width: "200px" } }>
                            { t('reports.download_report') }
                        </Button>
                    </div>
                </Form>
            </Spin>
        </Modal>
    );
};

export default ReportDepartmentMechModal;